import PropTypes from 'prop-types';
import moment from 'moment';
import StatusBanner from '@/componentsDS/StatusBanner';
import { ReactComponent as InfoIcon } from '@/assets/svgs/icon-info-filled.svg';
import { SUBMITTAL_STATUS } from '../constants';

const BANNER_CONFIG = {
    [SUBMITTAL_STATUS.DRAFT]: {
        getPrimary: () => 'Submission is saved as draft',
    },
    [SUBMITTAL_STATUS.PENDING_REVIEW]: {
        getPrimary: () => 'Submission is in pending review',
    },
    [SUBMITTAL_STATUS.APPROVED]: {
        getPrimary: (receiverOrgName) =>
            `E-Form submission was approved and shared to ${receiverOrgName || 'receiver'}`,
        showBy: true,
    },
    [SUBMITTAL_STATUS.REJECTED]: {
        getPrimary: () => 'Submission was rejected',
        showReasonCard: true,
    },
    [SUBMITTAL_STATUS.REPLACED]: {
        getPrimary: () => 'Submission has been replaced by a newer submission',
        showReasonCard: true,
    },
    [SUBMITTAL_STATUS.DELETED]: {
        getPrimary: () => 'Submission has been deleted',
    },
    [SUBMITTAL_STATUS.PASSED_DEADLINE]: {
        getPrimary: () => 'Submission deadline has passed',
    },
};

const SubmittalBanner = ({ status, receiverOrgName, latestLog, onViewActivityLog }) => {
    if (!latestLog) return null;

    const config = BANNER_CONFIG[status];
    if (!config) return null;

    const consultantLabel = latestLog.consultant?.email ?? latestLog.consultant?.name;
    const subtitle = [
        config.showBy && consultantLabel ? `by ${consultantLabel}` : null,
        latestLog.created ? `on ${moment(latestLog.created).format('DD MMM YYYY, h:mm A')}` : null,
    ].filter(Boolean).join(' ');

    return (
        <>
        <StatusBanner
            className="submittals-rejection-banner"
            icon={<InfoIcon />}
            title={config.getPrimary(receiverOrgName)}
            subtitle={subtitle || undefined}
            action={
                onViewActivityLog && (
                    <StatusBanner.Action onClick={onViewActivityLog}>
                        View Activity Log
                    </StatusBanner.Action>
                )
            }
        >
            {config.showReasonCard && latestLog.message && (
                <StatusBanner.Note variant="error">
                    <StatusBanner.Note.Heading>Reason for rejection:</StatusBanner.Note.Heading>
                    <StatusBanner.Note.Body>{latestLog.message}</StatusBanner.Note.Body>
                    {consultantLabel && (
                        <StatusBanner.Note.Meta>From: {consultantLabel}</StatusBanner.Note.Meta>
                    )}
                </StatusBanner.Note>
            )}
        </StatusBanner>
        <hr className="submittals-rejection-divider" />
        </>
    );
};

SubmittalBanner.propTypes = {
    status: PropTypes.string,
    receiverOrgName: PropTypes.string,
    latestLog: PropTypes.shape({
        created: PropTypes.string,
        message: PropTypes.string,
        consultant: PropTypes.shape({
            email: PropTypes.string,
            name: PropTypes.string,
        }),
    }),
    onViewActivityLog: PropTypes.func,
};

export default SubmittalBanner;
